<agr-form-dialog
  [formGroup]="formGroup"
  [hideActionButtons]="isViewModeView"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div class="flex--column">
    <mat-form-field class="flex__child--auto spacing--margin-top">
      <mat-label>{{ 'create-product.product-name' | translate }}</mat-label>
      <input
        matInput
        formControlName="productName"
        placeholder="{{ 'create-product.product-name' | translate }}"
        data-test="create-product__product-name"
      />
      <mat-error *ngIf="formGroup.controls.productName.invalid">
        {{ 'create-product.error-product-name' | translate }}</mat-error
      >
    </mat-form-field>

    <div>
      <agr-chips-filter
        [filterTitle]="'create-product.feedAdviceTypes-label' | translate"
        [multiple]="true"
        [items]="feedAdviceTypesOptions"
        [hideClear]="isViewModeView"
        [selectable]="!isViewModeView"
        data-test="chip-feedAdviceTypes"
        formControlName="feedAdviceTypes"
      ></agr-chips-filter>
      <mat-error *ngIf="formGroup.controls.feedAdviceTypes.invalid">
        {{ 'create-product.error-feedAdviceTypes-description' | translate }}
      </mat-error>
    </div>

    <div *ngIf="phasesIsVisible()">
      <agr-chips-filter
        [filterTitle]="'create-product.phases-label' | translate"
        [multiple]="true"
        [items]="suitablePhasesOptions"
        [hideClear]="isViewModeView"
        [selectable]="!isViewModeView"
        data-test="chip-suitable-phases"
        formControlName="suitablePhases"
      ></agr-chips-filter>
      <mat-error *ngIf="formGroup.controls.suitablePhases.invalid">
        {{ 'create-product.error-phases-description' | translate }}
      </mat-error>
    </div>

    <mat-form-field class="flex__child--auto spacing--margin-top">
      <mat-label>{{ 'create-product.product-code' | translate }}</mat-label>
      <input
        matInput
        formControlName="productCode"
        placeholder="{{ 'create-product.product-code' | translate }}"
        data-test="create-product__product-code"
      />
      <mat-error *ngIf="formGroup.controls.productCode.errors?.required">
        {{ 'create-product.error-product-code' | translate }}</mat-error
      >
      <mat-error *ngIf="formGroup.controls.productCode.errors?.productCodeAlreadyInUse">
        {{ 'create-product.error-code-already-in-use' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'create-product.energy' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        data-test="create-product__energy"
        formControlName="energy"
        placeholder="{{ 'create-product.energy' | translate }}"
      />
      <span matTextSuffix class="form-field-suffix">{{
        'settings.energy.short.' + (energySetting$ | async) | translate
      }}</span>
      <mat-error *ngIf="formGroup.controls.energy.errors?.required">
        {{ 'create-product.error-energy' | translate }}</mat-error
      >
      <mat-hint>{{ 'create-product.hint-energy' | translate }}</mat-hint>
    </mat-form-field>

    <mat-form-field class="flex__child--auto lysine">
      <mat-label>{{ 'create-product.lysine' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        data-test="create-product__lysine"
        formControlName="lysine"
        placeholder="{{ 'create-product.lysine' | translate }}"
      />
      <span matTextSuffix class="form-field-suffix">{{
        'settings.lysine.short.' + (lysineSetting$ | async) | translate
      }}</span>
      <mat-error *ngIf="formGroup.controls.lysine.errors?.required">
        {{ 'create-product.error-lysine' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <span matTextPrefix class="spacing--padding-half-right">{{ currency }}</span>
      <mat-label>{{ 'create-product.gross-price' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        data-test="create-product__gross-price"
        formControlName="grossPrice"
        placeholder="{{ 'create-product.gross-price' | translate }}"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'create-product.phosphorus' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        data-test="create-product__phosphorus"
        formControlName="phosphorus"
        placeholder="{{ 'create-product.phosphorus' | translate }}"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'create-product.protein' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        data-test="create-product__protein"
        formControlName="protein"
        placeholder="{{ 'create-product.protein' | translate }}"
      />
    </mat-form-field>
  </div>
</agr-form-dialog>
